import { Component } from 'react'
import { Layout } from 'antd';

const { Header } = Layout;

export default class header extends Component {
  render() {
        return (
            <Header style={{ background: '#001529', padding: '0 2rem' }}>
            <div style={{ color: 'white', fontSize: '20px' }}>
                <img src="/assets/logo.png" alt="Logo" style={{width:100,height:25,marginRight:10}} />
                AWS Marketplace Registration System
            </div>
            </Header>
        )
    }
}
